import { useState } from "react";
import "./editorialForms.css";

const fuelTypes = [
  { id: "gasoline", name: "Gasolina" },
  { id: "ethanol", name: "Etanol" },
  { id: "flex", name: "Flex" },
  { id: "diesel", name: "Diesel" },
  { id: "electric", name: "Elétrico" },
  { id: "hybrid", name: "Híbrido" },
];

const transmissionTypes = [
  { id: "manual", name: "Manual" },
  { id: "automatic", name: "Automático" },
  { id: "cvt", name: "CVT" },
  { id: "dct", name: "Automatizado (DCT)" },
];

const conditions = [
  { id: "new", name: "Zero KM" },
  { id: "used", name: "Usado" },
  { id: "certified", name: "Seminovo Certificado" },
];

export default function CarForm({ data, onChange }) {
  const [featureInput, setFeatureInput] = useState("");

  const handleAddFeature = () => {
    if (featureInput.trim()) {
      onChange({
        ...data,
        features: [...(data?.features || []), featureInput.trim()],
      });
      setFeatureInput("");
    }
  };

  const handleRemoveFeature = (index) => {
    onChange({
      ...data,
      features: (data?.features || []).filter((_, i) => i !== index),
    });
  };

  return (
    <div className="editorial_form car_form">
      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>
            Marca <span className="required">*</span>
          </label>
          <input
            type="text"
            placeholder="Ex: Honda, Toyota, Volkswagen..."
            value={data?.brand || ""}
            onChange={(e) => onChange({ ...data, brand: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>
            Modelo <span className="required">*</span>
          </label>
          <input
            type="text"
            placeholder="Ex: Civic, Corolla, Golf..."
            value={data?.model || ""}
            onChange={(e) => onChange({ ...data, model: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>
            Ano <span className="required">*</span>
          </label>
          <input
            type="number"
            placeholder="2024"
            value={data?.year || ""}
            onChange={(e) =>
              onChange({ ...data, year: parseInt(e.target.value) || 0 })
            }
            min="1900"
            max={new Date().getFullYear() + 1}
          />
        </div>

        <div className="editorial_form_section">
          <label>Versão</label>
          <input
            type="text"
            placeholder="Ex: EXL, Touring, TSI..."
            value={data?.version || ""}
            onChange={(e) => onChange({ ...data, version: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>Cor</label>
          <input
            type="text"
            placeholder="Ex: Preto, Prata, Branco..."
            value={data?.color || ""}
            onChange={(e) => onChange({ ...data, color: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Quilometragem</label>
          <input
            type="number"
            placeholder="50000"
            value={data?.mileage || ""}
            onChange={(e) =>
              onChange({ ...data, mileage: parseInt(e.target.value) || 0 })
            }
            min="0"
          />
        </div>

        <div className="editorial_form_section">
          <label>Combustível</label>
          <select
            value={data?.fuelType || ""}
            onChange={(e) => onChange({ ...data, fuelType: e.target.value })}
          >
            <option value="">Selecione</option>
            {fuelTypes.map((fuel) => (
              <option key={fuel.id} value={fuel.id}>
                {fuel.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Câmbio</label>
          <select
            value={data?.transmission || ""}
            onChange={(e) => onChange({ ...data, transmission: e.target.value })}
          >
            <option value="">Selecione</option>
            {transmissionTypes.map((trans) => (
              <option key={trans.id} value={trans.id}>
                {trans.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>
            Preço (R$) <span className="required">*</span>
          </label>
          <input
            type="number"
            placeholder="0"
            value={data?.price || ""}
            onChange={(e) =>
              onChange({ ...data, price: parseFloat(e.target.value) || 0 })
            }
            min="0"
          />
        </div>

        <div className="editorial_form_section">
          <label>Condição</label>
          <select
            value={data?.condition || "used"}
            onChange={(e) => onChange({ ...data, condition: e.target.value })}
          >
            {conditions.map((cond) => (
              <option key={cond.id} value={cond.id}>
                {cond.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Donos Anteriores</label>
          <input
            type="number"
            placeholder="1"
            value={data?.owners || ""}
            onChange={(e) =>
              onChange({ ...data, owners: parseInt(e.target.value) || 0 })
            }
            min="0"
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Placa (Final)</label>
        <input
          type="text"
          placeholder="Ex: Final 5"
          value={data?.licensePlate || ""}
          onChange={(e) => onChange({ ...data, licensePlate: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>
          Opcionais
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddFeature}
          >
            + Adicionar
          </button>
        </label>
        <input
          type="text"
          placeholder="Ex: Teto solar, Banco de couro, Multimídia..."
          value={featureInput}
          onChange={(e) => setFeatureInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddFeature()}
        />
        <div className="genre_chips" style={{ marginTop: "8px" }}>
          {(data?.features || []).map((feature, i) => (
            <span
              key={i}
              className="genre_chip selected"
              onClick={() => handleRemoveFeature(i)}
              style={{ cursor: "pointer" }}
            >
              {feature} ×
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_section">
        <div className="editorial_form_checkboxes">
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="negotiable"
              checked={data?.negotiable !== false}
              onChange={(e) =>
                onChange({ ...data, negotiable: e.target.checked })
              }
            />
            <label htmlFor="negotiable">Aceito negociação</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="acceptsTrade"
              checked={data?.acceptsTrade || false}
              onChange={(e) =>
                onChange({ ...data, acceptsTrade: e.target.checked })
              }
            />
            <label htmlFor="acceptsTrade">Aceito troca</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="hasWarranty"
              checked={data?.hasWarranty || false}
              onChange={(e) =>
                onChange({ ...data, hasWarranty: e.target.checked })
              }
            />
            <label htmlFor="hasWarranty">Com garantia</label>
          </div>
        </div>
      </div>

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z" />
        </svg>
        <span>
          Fotos de qualidade com diferentes ângulos aumentam as chances de venda!
        </span>
      </div>
    </div>
  );
}
